export const locale = {
    LISTS: {
    NoData: "داده ای وجود ندارد",
    NoDataFound: "داده ای پیدا نشد",
    NoDataFoundFor: "داده ای برای {a} پیدا نشد",
    NoPhoneNumber: "شماره ای پیدا نشد",
    NoPostalCode: "کد پستی ای پیدا نشد",
    AddANumber: "هیچ شماره‌ای اضافه نشده است.",
    City: "شهر",
    AddedBefore: "قبلا اضافه شده است",
  },
  dashboard_origin: "داشبورد",
  menu: "منو",
  get_menu_again: "دریافت مجدد منو",
  loading_error: {
    title: "خطا در بارگزاری!",
    message: "بارگزاری اطلاعات با خطا مواجه شد! لطفا دوباره تلاش نمایید",
    text: "تلاش مجدد",
  },
  copy_right: {
    year: "۱۴۰۴",
    text1: "کلیه حقوق مادی و معنوی این سامانه محفوظ و متعلق به شرکت تبلیغاتی",
    text2: "کارآفرینان برتر",
    text3: "سپهر آراد می باشد ، هرگونه کپی برداری پیگرد قانونی دارد.",
  },
  user: "کاربر عزیز",
  hi: "سلام",
  exit: "خروج",
  go_to_page: "برو به صفحه",
  show: "نمایش",
  until: "تا",
  from: "از",
  page: "صفحه",
  notes: "یادداشت ها",
  created_at: "تاریخ ایجاد",
  registration: "ثبت",
  edit_contact: "ویرایش مخاطب",
  cancel: "انصراف",
  edit: "ویرایش",
  delete: "حذف",
  contact_info: "اطلاعات تماس",
  add_birthday: "افزودن تاریخ تولد",
  contacts: "دفترچه تلفن‌ها",
  last_updated_at: "آخرین ویرایش",
  added_to_contact: "به مخاطبین اضافه شده",
  contact_registered: "مخاطب شما ذخیره نشده است.",
  transaction: "تراکنش",
  write_message: "نوشتن پیام",
  note_title: "عنوان یادداشت",
  create_note: "افزودن یادداشت",
  are_you_sure_to_delete: "آیا از حذف مطمئن هستید؟",
  last_transaction: "آخرین تراکنش ها",
  your_balance: "موجودی شما",
  no_transaction: "هنوز تراکنشی برای شما ثبت نشده است!",
  increase_balance: "افزایش موجودی",
  transaction_list: "لیست تراکنش ها",
  withdraw: "برداشت وجه",
  decrease: "برداشت وجه",
  deposit: "واریز وجه",
  increase: "واریز وجه",
  charge: "شارژ کیف پول",
  refund: "بازگشت وجه",
  save: "ذخیره",
  reload: "بارگیری مجدد لیست",
  shared: "اشتراک گذاشته شده",
  list: "لیست",
  single_add: "افزودن تکی",
  mass_add: "افزودن گروهی",
  excel_add: "افزودن اکسل",
  added_successfully: "با موفقیت اضافه شد",
  error_add_phone: "خطا در افزودن شماره",
  group: {
    add: "افزودن گروه جدید",
    delete: "حذف گروه",
    edit: "ویرایش گروه",
    first: "لطفا ابتدا گروه جدید اضافه نمایید.",
  },
  successfully_deleted: "با موفقیت حذف شد",
  notification: {
    text: "نوتیفیکیشن های کاربر",
    new: "پیام جدید",
    messages: "پیام ها",
    events: "رویدادها",
    no_new_message: "پیام جدیدی موجود نیست!",
    show_all: "مشاهده همه",
    no_new_event: "رویداد جدیدی موجود نیست!",
    go_to_user: "برو به کاربر",
    watched: "مشاهده کردم",
  },
  locking_for_service: "دنبال چه خدمتی هستید؟",
  service_name: "نام سرویس مورد نظر خودرا وارد کنید...",
  invite: {
    title: "سامانه را به دوستان خود معرفی کنید.",
    gift: "قاب خاطره ها",
    get: "دریافت کنید.",
    phone: "شماره را وارد نمایید.",
    invite: "دعوت کن!",
    got_it: "متوجه شدم",
    get_gift: "دریافت قاب خاطره ها",
    success: "پیام دعوت شما با موفقیت ارسال شد.",
    wrong_number: "لطفا شماره صحیح وارد نمایید.",
  },
  ticker: {
    text: "در هر لحظه با شما هستیم...",
    help: "برای ارتباط با تیم پشتیبانی ما تیکت ثبت نمایید",
    register: "ثبت تیکت",
  },
  package: {
    title: "بسته های فعال",
    no: "شما هیچ بسته فعالی ندارید.",
    no_limit: "پنل نامحدود",
    day: " روزه",
    other: " دیگر",
    expiration: "انقضا ",
    expired: "منقضی شده ",
  },
  Loading: {
    Waiting: "لطفا صبر کنید",
    Description: "چند لحظه صبر کنید",
  },
  Questions: {
    Yes: "بله",
    No: "خیر",
  },
  Success: {
    Title: "موفقیت آمیز",
    defaultActionText: "متوجه شدم",
  },
  Info: {
    Title: "اطلاع رسانی",
    defaultActionText: "متوجه شدم",
  },
  Warning: {
    Title: "توجه",
    defaultActionText: "متوجه شدم",
  },
  Error: {
    Title: "خطا",
    defaultActionText: "متوجه شدم",
  },
  Wallet: {
    Title: "موجوی ناکافی",
    defaultActionText: "متوجه شدم",
  },
  ConnectionLost: {
    Title: "اینترنت شما قطع شده است",
    Subtitle: "لطفا از اتصال اینترنت خود مطمئن شوید",
    Button: "تلاش مجدد",
  },
  emoji: "ایموجی",
  text_suggest_free: "مشاور متن (رایگان)",
  select_campaign: "انتخاب کمپین",
  short_link: "لینک کوتاه",
  text_suggest: "مشاور متن",
  select_emoji: "انتخاب ایموجی",
  default_text: "متن پیشفرض",
  emoji_group: {
    "Smileys & Emotion": "شکلک‌ها و احساسات",
    "People & Body": "آدم‌ها و بدن",
    "Animals & Nature": "حیوانات و طبیعت",
    "Food & Drink": "خوراکی و نوشیدنی",
    "Travel & Places": "سفر و مکان‌ها",
    Activities: "فعالیت‌ها",
    Objects: "اشیا",
    Symbols: "نمادها",
    Flags: "پرچم‌ها",
  },
  table: {
    index: "ردیف",
    title: "عنوان",
    text: "متن",
    select: "انتخاب",
    next: "بعدی",
    previous: "قبلی",
    rows_per_page: "تعداد در صفحه",
    no_data: "داده‌ای برای نمایش وجود ندارد",
    search_placeholder: "جستجو",
  },
  modal: {
    success: "موفقیت",
  },
  actions: {
    remove: "حذف",
    copyLink: "کپی لینک",
    operations: "عملیات",
    edit: "ویرایش",
    delete: "حذف",
    show: "نمایش",
    accept: "تایید",
    reject: "رد",
    enable: "فعال‌سازی",
    download: "دانلود",
    deactive: "غیرفعال",
  },

  shortLink: {
    freeShorten: 'لینک‌های خود را "رایگان" کوتاه کنید.',
    clickToSelect: "برای انتخاب، روی لینک مورد نظر کلیک کنید.",
    create: "ساخت لینک کوتاه",
    title: "عنوان",
    titleHint: "لطفا یک نام برای لینک کوتاه خود اضافه کنید.",
    link: "لینک",
    linkHint: "لینک مورد نظر خود را وارد کنید.",
    shortenedLink: "لینک کوتاه شده",
    clickCount: "تعداد کلیک",
    selectDomain: "انتخاب دامنه",
  },
  pagination: {
    next: "بعدی",
    previous: "قبلی",
    rowsPerPage: "تعداد در صفحه",
    noData: "داده ای برای نمایش وجود ندارد",
    search: "جستجو",
  },
  validation: {
    titleRequired: "عنوان الزامی است",
    minLength4: "حداقل 4 کاراکتر مجاز است",
    linkRequired: "لینک الزامی است",
    mustIncludeHttps: "باید شامل https:// باشد",
    invalidLink: "لطفا لینک صحیح وارد نمایید.",
  },
  messages: {
    addedSuccessfully: "با موفقیت اضافه شد.",
    confirmDeleteShortLink: "تایید حذف لینک کوتاه؟",
  },
  inputMenu: {
    text: "متن",
    selectUserInfo: "انتخاب مشخصات کاربر",
  },
  patternDialog: {
    title: "انتخاب پترن/کمپین",
    change: "تغییر پترن/کمپین",
    createPattern: "ثبت پترن جدید",
    createCampaign: "ثبت کمپین جدید",
    tabs: {
      pattern: "انتخاب پترن",
      campaign: "انتخاب کمپین",
    },
    empty: "الگویی پیدا نشد، ابتدا یک الگو ثبت فرمایید.",
    columns: {
      id: "شناسه",
      type: "نوع",
      pattern: "پترن",
      static: "ثابت",
      title: "عنوان",
      content: "متن",
      status: "وضعیت",
      rejected: "رد شده",
      approved: "تایید شده",
    },
    pagination: {
      next: "بعدی",
      prev: "قبلی",
      rowsPerPage: "تعداد در صفحه",
      noData: "داده ای برای نمایش وجود ندارد",
      search: "جستجو",
    },
  },
  PATTERN: {
    SELECTED_MESSAGE: "پیام انتخاب شده:",
    REQUIRED_INPUTS: "ورودی های اجباری:",
    SELECTED_CAMPAIGN: "کمپین انتخاب شده:",
    CAMPAIGN_ID: "شناسه",
    PRE_NAME: "پیشوند",
    NAME: "نام",
    MIDDLE_NAME: "نام میانی",
    LAST_NAME: "نام خانوادگی",
    POST_NAME: "پسوند",
    ALIAS: "نام مستعار",
    COMPANY: "شرکت",
    JOB_TITLE: "عنوان شغلی",
    PHONE: "شماره تلفن",
    BIRTHDAY: "تاریخ تولد",
    DESCRIPTION: "توضیحات",
  },
  CONTACT_GROUP: {
    LIST: "لیست",
    ADD: "افزودن",
    SEARCH: "جستجو",
    INDEX: "ردیف",
    ID: "شناسه",
    GROUP_NAME: "نام گروه",
    PARENT: "والد",
    CREATE: {
      GROUP_NAME: "نام گروه پیشفرض",
      PARENT_CATEGORY: "دسته‌بندی والد",
      ADD_GROUP: "افزودن گروه",
      SUCCESS: "گروه پیشفرض با موفقیت اضافه شد.",
      ERROR: "خطا در افزودن گروه پیشفرض!",
      SEARCH: "جستجو",
      TITLE: "عنوان",
      SEARCH_IN_TITLE: "جستجو در عنوان",
      FROM: "از",
      TO: "تا",
      BIRTHDAY_FROM: "تاریخ تولد از",
      BIRTHDAY_TO: "تا تاریخ",
      ITEMS_PER_PAGE: "تعداد در صفحه",
      PHONE_COPY: "کپی شماره",
      COPY_PHONE: "کپی شماره",
      DELETE_CONTACT_GROUP: "حذف مخاطب از گروه",
      DELETE_FROM_GROUP_ONLY: "مخاطب فقط از این گروه حذف شود",
      DELETE_FROM_ALL_GROUPS: "مخاطب از کلیه گروه‌ها حذف شود",
      USER: "کاربر",
      PHOTO: "عکس",
      FULL_NAME: "نام و نام‌خانوادگی",
      EMAIL: "ایمیل",
      PHONE_NUMBER: "شماره همراه",
      JOB_TITLE_COMPANY: "عنوان شغلی و شرکت",
      CREATED_AT: "زمان ایجاد",
      PHONEBOOK: "دفترچه تلفن",
      ACTIONS: "عملیات",
    },
    TITLE: "عنوان",
    SEARCH_IN_TITLE: "جستجو در عنوان",
    FROM: "از",
    TO: "تا",
    BIRTHDAY_FROM: "تاریخ تولد از",
    BIRTHDAY_TO: "تا تاریخ",
    ITEMS_PER_PAGE: "تعداد در صفحه",
    PHONE_COPY: "کپی شماره",
    COPY_PHONE: "کپی شماره",
    DELETE_CONTACT_GROUP: "حذف مخاطب از گروه",
    DELETE_FROM_GROUP_ONLY: "مخاطب فقط از این گروه حذف شود",
    DELETE_FROM_ALL_GROUPS: "مخاطب از کلیه گروه‌ها حذف شود",
    USER: "کاربر",
    PHOTO: "عکس",
    FULL_NAME: "نام و نام‌خانوادگی",
    EMAIL: "ایمیل",
    PHONE_NUMBER: "شماره همراه",
    JOB_TITLE_COMPANY: "عنوان شغلی و شرکت",
    CREATED_AT: "زمان ایجاد",
    PHONEBOOK: "دفترچه تلفن",
    ACTIONS: "عملیات",
  },
  GRADUAL: {
    SEND_GRADUAL: "ارسال تدریجی",
    ALLOWED_HINT: "برای ارسال با تعداد شماره بیشتر از ۵۰۰ عدد",
    SEND_GRADUAL_OPTION: "ارسال به صورت تدریجی",
    AFTER_EVERY: "پس از هر چند",
    SEND_SMS: "پیامک ها ارسال شود؟",
    TIME_INTERVAL: "فاصله زمانی",
    SMS_PART: "تعداد پیامک",
    SMS_PART_HINT: "تعداد پیامک در هر پارت ارسالی را وارد نمایید.",
    COUNT_ERROR: "تعداد پیامک در هر پارت نمی‌تواند کمتر از ۵۰۰ باشد!",
  },
  HISTORY: {
    CREATE_NEW: "ایجاد تاریخچه جدید",
    BACK: "بازگشت",
    TITLE: "عنوان تاریخچه",
    STEP: "مرحله",
    LAST_CALL: "زمان آخرین تماس",
    DISCUSSIONS: "مذاکرات انجام شده",
    REMIND_DATE: "زمان یادآوری",
    FOLLOWUP: "موارد پیگیری در تماس بعدی",
    SAVE_HISTORY: "ذخیره تاریخچه",
    INDEX: "ردیف",
    SAVED_BY: "ثبت کننده",
    ACTION: "مدیریت",
    MORE_INFO: "اطلاعات بیشتر درباره",
    CREATE_ERROR: "خطا در افزودن تاریخچه مشتری!",
  },
  FORMS: {
    SourceNumber: "سرشماره",
    DestinationPhone: "شماره مقصد",
    Add: "افزودن",
    SEND_TO_SELECTED_NUMBERS: "ارسال به شماره‌های انتخاب شده",
    CHANGE_PATTERN_CAMPAIGN: "تغییر پترن/کمپین",
    SendTime: "زمان ارسال",
    SELECTED_MESSAGE: "پیام انتخاب شده",
    REQUIRED_INPUTS: "ورودی های اجباری",
    SELECTED: "انتخاب شده",
    ID: "شناسه",
    SEND: "ارسال",
    DATE_REQUIRED: "انتخاب تاریخ الزامی است.",
    TIME_INTERVAL: "فاصله زمانی",
    TIME_INTERVAL_FROM_PREVIOUS: "فاصله زمانی از پیام قبلی",
    Title: "عنوان",
    LINK: "لینک",
    LINK_HINT: "any",
    LINK_PLACEHOLDER: "مثال‌: (https://example.ex/any)",
    LINK_SHORTENED_HINT:
      "لینک شما پس از کوتاه شدن به طول ۱۴ حرف جایگزین (example.ex/any) داخل متن قرار گرفته و لینک اختصاصی برای هر پیام ارسال خواهد شد.",
    Text: "متن",
    MUST_INCLUDE_PATTERN: "بایستی شامل عبارت {pattern} باشد",
    INVALID_LINK: "لینک صحیح وارد نمایید",
  },
  ERRORS: {
    VpnDetectedTitle: "VPN خود را خاموش کنید",
    VpnDetectedSubtitle:
      "این کار باعث می‌شود سامانه بهتر عمل کند و شما تجربه بهتری داشته باشید.",
    PhoneIsNotValid: "شماره تلفن معتبر نیست",
    MaxPhoneLimit: "شما نمی توانید بیشتر از 50000 شماره اضافه کنید.",
    NoSelectedLineNumber: "سرشماره‌ای انتخاب نشده است.",
    INVALID_TIMER: "زمان صحیح وارد نمایید",
    PhoneIsNotValid: "شماره تلفن معتبر نیست",
    MaxPhoneLimit: "شما نمی‌توانید بیشتر از ۵۰۰۰۰ شماره اضافه کنید.",
    NoSelectedLineNumber: "سرشماره‌ای انتخاب نشده است.",
    INVALID_TIMER: "زمان صحیح وارد نمایید",
    NoAccess: "دسترسی ندارید",
    PleaseBuyAPlane: "لطفاً یک طرح خریداری کنید",
    NoAccountCharge: "موجودی حساب کافی نیست",
    PleaseChargeYourAccount: "لطفاً حساب خود را شارژ کنید",
    Unauthorized: "عدم دسترسی: لطفاً دوباره وارد شوید",
    ServerError: "خطای سرور رخ داده است، لطفاً بعداً تلاش کنید",
    NetworkError: "خطای شبکه: لطفاً اتصال اینترنت خود را بررسی کنید",
    InvalidInput: "ورودی نامعتبر است",
    SessionExpired: "جلسه شما منقضی شده است، لطفاً دوباره وارد شوید",
    TokenInvalid: "توکن نامعتبر است",
    VpnDetected: "فیلترشکن شما فعال است، لطفاً آن را خاموش کنید",
    RequestTimeout: "درخواست شما منقضی شد، لطفاً دوباره تلاش کنید",
    DuplicateEntry: "این مورد قبلاً ثبت شده است",
  },

  BUTTONS: {
    DELETE_NUMBERS: "حذف شماره‌ها",
    ADD_BULK: "افزودن گروهی",
    FROM_FILE: "از فایل",
    More: "بیشتر",
    BuyAPlane: "خرید طرح",
    AccountCharge: "شارژ حساب",
    OK: "تأیید",
    Close: "بستن",
    Cancel: "لغو",
    Retry: "تلاش مجدد",
    Login: "ورود",
    Logout: "خروج",
    Save: "ذخیره",
    Submit: "ارسال",
  },
  GENERAL: {
    row: "ردیف",
    id: "شناسه",
    back: "بازگشت",
    manage: "مدیریت",
    SENDING: "درحال ارسال",
    RELOAD: "بارگیری مجدد",
    PRINT: "چاپ",
    DELETE: "حذف",
    SUBMIT: "ارسال",
    SUCCESSFULLY_ADDED: "با موفقیت اضافه شد",
    RELOAD: "بارگیری مجدد",
    CANCEL: "لغو",
    SUCCESSFULLY_DOWNLOADED: "با موفقیت دانلود شد",
    Loading: "در حال بارگذاری...",
    NoData: "داده‌ای یافت نشد",
    Welcome: "خوش آمدید",
    Profile: "پروفایل",
    Settings: "تنظیمات",
    Wallet: "کیف پول",
    Dashboard: "داشبورد",
  },

  NOTICES: {
    Attention: "توجه فرمایید",
    MinimumSendWarning:
      'در زمان ارسال پیامک با سرشماره "ارسال خبری" حداقل تعداد بایستی {{number}} عدد باشد.',
  },
  contactsTags: {
    select_group: "انتخاب گروه",
    create_group: "ایجاد گروه",
    search: "جستجو",
    add_group: "افزودن گروه",
    enter_group_name: "نام مورد نظر خود را وارد نمایید",
    group_name: "نام گروه",
    cancel: "انصراف",
    edit: "ویرایش",
    save: "ذخیره",
    loading_categories: "درحال بارگیری دسته‌بندی‌ها...",
    select_group_and_subgroup: "انتخاب گروه و زیرگروه",
    add_group_with_subgroups: "گروه به همراه زیر گروه ها اضافه شود",
    add_group_only: "گروه انتخاب شده فقط اضافه شود",
    duplicate_name_error: "نام تکراری میباشد",
    added_successfully: "با موفقیت اضافه شد.",
    confirm_delete_group: "تایید حذف گروه؟",
    deleted_successfully: "با موفقیت حذف شد",
    edited_successfully: "با موفقیت ویرایش شد",
    group_added_successfully: "گروه(های) انتخاب شده با موفقیت اضافه شدند.",
    error_creating_group: "خطا در افزودن گروه پیشفرض",
    create_default_group: "ساخت گروه پیشفرض",
    select_default_group: "انتخاب گروه پیشفرض",
    add_custom_group: "افزودن گروه با نام دلخواه",
  },
  CONTACT_SHARE: {
    ADD_PHONE_NUMBER: "افزودن شماره تلفن",
    ADD: "افزودن",
    SHARE_ACCESS:
      "با انتخاب هریک از موارد زیر، دسترسی مورد نظر را با دیگران به اشتراک بگذارید.",
    SELECT_ACCESS: "انتخاب دسترسی برای دفترچه تلفن",
    DELETE: "حذف",
    EDIT: "ویرایش",
    SEND: "ارسال",
    PERSONS_WITH_ACCESS: "افرادی که دسترسی دارند",
    REMOVE_ACCESS: "برداشتن دسترسی",
    RETURN: "بازگشت",
    SAVE_CHANGES: "ذخیره تغییرات",
    SHARE_CONTACT_BOOK: "اشتراک گذاری دفترچه تلفن",
    PHONE_VALIDATION: "شماره تلفن صحیح وارد نماید",
    SUCCESS_SHARE: "دفترچه تلفن با موفقیت به اشتراک گذاشته شد.",
    ERROR_SHARE: "خطا در اشتراک گذاری دفترچه تلفن!",
    PHONE_DUPLICATE: "شماره قبلا وارد شده است!",
    CHANGES_SAVED: "تغییرات با موفقیت ذخیره شدند.",
    ERROR_SAVING_CHANGES: "خطا در دخیره تغییرات!",
  },
  CONTACT_SEARCH: {
    SEARCH: "جستجو",
    ADD_NUMBER: "شماره اضافه کنید",
  },
  CONTACT_PAGINATION: {
    PER_PAGE: "تعداد در هر صفحه",
    FROM: "از",
    TO: "تا",
    TOTAL: "تعداد کل",
  },
  SUCCESS: {
    DELETED: "با موفقیت حذف شد",
    SUCCESS: "موفقیت",
  },
  CONFIRM: {
    DELETE_BULK: "حذف شماره‌های ذخیره نشده‌؟",
  },
  TOOLTIP: {
    CopyPhoneNumbers: "شماره های خودرا کپی کنید و سپس کلیک کنید",
    COPY_LINK: "کپی لینک",
    COPY_NUMBER: "کپی شماره",
    SEE_PROFILE: "مشاهده پروفایل",
  },
  CONTACT_EDIT: {
    EDIT: "ویرایش",
    DELETE: "حذف",
  },
  CONTACT_MENU: {
    SHARE: "اشتراک گذاری",
    PRINT: "چاپ",
    EXCEL_EXPORT: "خروجی اکسل",
    DELETE: "حذف",
    SUCCESS_DELETE: "با موفقیت حذف شد.",
    ERROR_DELETE: "خطا در حذف مخاطبین!",
  },
  CONTACTS: {
    PREFIX: "پیشوند",
    NAME: "نام",
    MIDDLENAME: "نام میانی",
    LASTNAME: "نام خانوادگی",
    POSTFIX: "پسوند",
    ALIAS: "نام مستعار",
    COMPANY: "شرکت",
    JOBTITLE: "عنوان شغلی",
    PHONE: "شماره تلفن",
    PHONE_PLACEHOLDER: "مانند: 8070 111 13 (989)(989+)(9)(09)",
    ADD_EMAIL: "افزودن ایمیل",
    EMAIL: "ایمیل",
    ADD_ADDRESS: "افزودن نشانی",
    ADDRESS: "نشانی",
    PROVINCE: "استان",
    CITY: "شهر",
    POSTALCODE: "کدپستی",
    YEAR_OPTIONAL: "سال (اختیاری)",
    MONTH: "ماه",
    DAY: "روز",
    ADD_BIRTHDAY: "افزودن تاریخ تولد",
    ADD_WEBSITE: "افزودن وب سایت",
    WEBSITE: "وب سایت",
    ADD_DATE: "افزودن تاریخ",
    DATE: "تاریخ",
    CUSTOM_FIELD: "فیلد سفارشی",
    ADD_CUSTOM_FIELD: "افزودن فیلد سفارشی",
    NOTE: "توضیحات",
    ADD_NOTE: "افزودن یادداشت",
    HOME: "خانه",
    WORK: "محل کار",
    OTHER: "سایر موارد",
    PROFILE: "نمایه",
    BLOG: "وبلاگ",
    HOMEPAGE: "صفحه اصلی",
    TITLE: "عنوان",
    BIRTHDAY_ERROR: "تاریخ را به صورت صحیح وارد نمایید",
    YEAR_ERROR: "۴ رقمی",
    EMAIL_ERROR: "ایمیل به صورت صحیح وارد نمایید",
    WEBSITE_ERROR: "لینک به صورت صحیح وارد نمایید (website.com)",
    PHONE_ERROR: "شماره تلفن صحیح وارد نماید",
    ADD_HISTORY: "افزودن تاریخچه",
    HISTORY_LIST: "لیست تاریخچه‌ها",
    EDIT_CONTACT: "ویرایش مخاطب",
    SHOW_CONTACT: "نمایش مخاطب",
  },
  MONTHS: {
    FARVARDIN: "فروردین",
    ORDIBEHESHT: "اردیبهشت",
    KHORDAD: "خرداد",
    TIR: "تیر",
    MORDAD: "مرداد",
    SHAHRIVAR: "شهریور",
    MEHR: "مهر",
    ABAN: "آبان",
    AZAR: "آذر",
    DEY: "دی",
    BAHMAN: "بهمن",
    ESFAND: "اسفند",
  },

  UPLOAD_EXCEL: {
    DOWNLOAD_SAMPLE: "دانلود و استفاده از فایل نمونه اکسل",
    UPLOAD_TITLE: "آپلود فایل",
    DRAG_DROP_TEXT_PART1: "برای آپلود بکشید و رها کنید یا",
    DRAG_DROP_TEXT_PART2: "اینجا",
    DRAG_DROP_TEXT_PART3: "کلیک کنید",
    FILE_INPUT_LABEL: "بارگذاری فایل اکسل",
  },
  SUCCESS_MESSAGE: {
    LINK_COPIED: "لینک با موفقیت کپی شد!",
  },
  ERROR_MESSAGE: {
    COPY_LINK_FAILED: "خطا در کپی کردن لینک.",
  },
  POPUP: {
    TITLE_OR_BUTTON_TEXT: "انتخاب پترن/کمپین",
    BUTTON_EDIT_TEXT: "تغییر پترن/کمپین",
  },
  BUTTON: {
    REGISTER_NEW_PATTERN: "ثبت پترن جدید",
    REGISTER_NEW_CAMPAIGN: "ثبت کمپین جدید",
    CREATE_NEW_HISTORY: "ایجاد تاریخچه جدید",
    SAVE_HISTORY: "ذخیره تاریخچه",
    SELECT_GROUP: "انتخاب گروه",
    CREATE_GROUP: "ایجاد گروه",
    ADD_GROUP: "افزودن گروه",
    SAVE: "ذخیره",
    CREATE_GROUP_SINGULAR: "ساخت گروه",
    ADD: "افزودن",
    SEND: "ارسال",
    EDIT_PERMISSIONS: "ویرایش",
    GO_BACK: "بازگشت",
    SAVE_CHANGES: "ذخیره تغییرات",
    GUIDE: "راهنما",
    START: "شروع",
    EDIT: "ویرایش",
    CANCEL: "لغو",
    AUTO_REFRESH: "به‌روزرسانی خودکار",
    AUTO_REFRESH_SETTINGS: "تنظیم به‌روزرسانی خودکار",
    BACK: "بازگشت",
  },
  TABS: {
    SELECT_PATTERN: "انتخاب پترن",
    SELECT_CAMPAIGN: "انتخاب کمپین",
    LIST: "لیست",
    ADD: "افزودن",
    ADD_CUSTOM_GROUP: "افزودن گروه با نام دلخواه",
    SELECT_DEFAULT_GROUP: "انتخاب گروه پیشفرض",
  },
  NO_DATA: {
    NO_PATTERN: "الگویی پیدا نشد، ابتدا یک الگو ثبت فرمایید.",
  },
  TABLE: {
    ID: "شناسه",
    TYPE: "نوع",
    PATTERN: "پترن",
    STATIC: "ثابت",
    TITLE: "عنوان",
    TEXT: "متن",
    STATUS: "وضعیت",
    REJECTED: "رد شده",
    ACCEPTED: "تایید شده",
    NEXT_BUTTON: "بعدی",
    PREVIOUS_BUTTON: "قبلی",
    ROWS_PER_PAGE_TEXT: "تعداد در صفحه",
    NO_DATA_TEXT: "داده ای برای نمایش وجود ندارد",
    PLACEHOLDER_SEARCH: "جستجو",
    MORE_INFO_ABOUT_ITEM: "اطلاعات بیشتر درباره {name}",
  },
  MENU_ITEMS: {
    TEXT_INPUT: "متن",
    SELECT_USER_INFO: "انتخاب مشخصات کاربر",
  },
  TABLE_CONTROLS: {
    COUNT: "تعداد",
    SEARCH: "جستجو",
  },
  FORM_LABELS: {
    DEFAULT_GROUP_NAME: "نام گروه پیشفرض",
    PARENT_CATEGORY: "دسته‌بندی والد",
    HISTORY_TITLE: "عنوان تاریخچه",
    STEP: "مرحله",
    LAST_CALL_TIME: "زمان آخرین تماس",
    NEGOTIATIONS: "مذاکرات انجام شده",
    REMINDER_TIME: "زمان یادآوری",
    FOLLOW_UP_ITEMS: "موارد پیگیری در تماس بعدی",
    GROUP_NAME: "نام گروه",
    SEARCH: "جستجو",
    TITLE: "عنوان",
    SEARCH_IN_TITLE: "جستجو در عنوان",
    FROM: "از",
    TO: "تا",
    BIRTHDAY_FROM: "تاریخ تولد از",
    BIRTHDAY_TO: "تا تاریخ",
    COUNT: "تعداد",
    ADD_PHONE_NUMBER: "افزودن شماره تلفن",
  },
  TOAST: {
    Success: "عملیات با موفقیت انجام شد",
    Error: "خطایی رخ داده است",
    Warning: "هشدار: لطفاً ورودی‌ها را بررسی کنید",
    AUTO_REFRESH_STARTED: "به‌روزرسانی خودکار شروع شد.",
    DEFAULT_GROUP_SUCCESS: "گروه پیشفرض با موفقیت اضافه شد.",
    DEFAULT_GROUP_ERROR: "خطا در افزودن گروه پیشفرض!",
    ADD_HISTORY_ERROR: "خطا در افزودن تاریخچه مشتری!",
    DUPLICATE_NAME: "نام تکراری میباشد",
    TAG_ADDED_SUCCESS: "برچسب با موفقیت اضافه شد.",
    TAG_DELETED_SUCCESS: "برچسب با موفقیت حذف شد",
    TAG_EDITED_SUCCESS: "برچسب با موفقیت ویرایش شد",
    GROUPS_ADDED_SUCCESS: "گروه(های) انتخاب شده با موفقیت اضافه شدند.",
    ADD_GROUP_ERROR: "خطا در افزودن گروه پیشفرض!",
    PHONE_COPIED_SUCCESS: "شماره همراه کپی شد.",
    SUCCESSFULLY_DELETED: "با موفقیت حذف شد",
    ERROR_DELETING_CONTACT_FROM_PHONEBOOK: "خطا در حذف مخاطب از دفترچه تلفن!",
    SHARE_SUCCESS: "دفترچه تلفن با موفقیت به اشتراک گذاشته شد.",
    SHARE_ERROR: "خطا در اشتراک گذاری دفترچه تلفن!",
    NUMBER_ALREADY_ADDED: "شماره قبلا وارد شده است!",
    CHANGES_SAVED_SUCCESS: "تغییرات با موفقیت ذخیره شدند.",
    CHANGES_SAVE_ERROR: "خطا در دخیره تغییرات!",
  },
  HEADERS: {
    GRADUAL_SEND: "ارسال تدریجی",
    GRADUAL_SEND_HINT: "(برای ارسال با تعداد شماره بیشتر از ۵۰۰ عدد)",
  },
  CHECKBOX_LABELS: {
    GRADUAL_SENDING: "ارسال به صورت تدریجی",
    DELETE: "حذف",
    EDIT: "ویرایش",
    ADD: "افزودن",
  },
  MESSAGES: {
    SENDING_INTERVAL_QUESTION: "پس از هر چند {time} پیامک ها ارسال شود؟",
  },
  LABELS: {
    TIME_INTERVAL: "فاصله زمانی",
    MESSAGE_COUNT: "تعداد پیامک",
  },
  TIME_TYPES: {
    MINUTE: "دقیقه",
    HOUR: "ساعت",
    DAY: "روز",
    WEEK: "هفته",
    SECOND: "ثانیه",
  },
  HINTS: {
    MESSAGE_COUNT_PER_PART: "تعداد پیامک در هر پارت ارسالی را وارد نمایید.",
  },
  RULES: {
    MESSAGE_COUNT_MIN_LIMIT:
      "تعداد پیامک در هر پارت نمی‌تواند کمتر از ۵۰۰ باشد!",
  },
  TABLE_HEADERS: {
    ROW: "ردیف",
    TITLE: "عنوان",
    STEP: "مرحله",
    REMINDER_TIME: "زمان یادآور",
    LAST_CALL_TIME: "زمان آخرین تماس",
    RECORDER: "ثبت کننده",
    MANAGEMENT: "مدیریت",
    ID: "شناسه",
    GROUP_NAME: "نام گروه",
    PARENT: "والد",
    CREATED_AT: "ایجاد",
    IMAGE: "عکس",
    FULL_NAME: "نام و نام‌خانوادگی",
    EMAIL: "ایمیل",
    PHONE_NUMBER: "شماره همراه",
    JOB_COMPANY: "عنوان شغلی و شرکت",
    CREATION_TIME: "زمان ایجاد",
    PHONEBOOK: "دفترچه تلفن",
    ACTIONS: "عملیات",
    USER: "کاربر",
  },
  PROPS: {
    SOURCE_NUMBER_LABEL: "سرشماره",
  },
  MODAL: {
    INFO_TITLE: "توجه فرمایید.",
    INFO_MESSAGE_NEWS_NUMBER:
      'در زمان  ارسال پیامک با سرشماره "{number}"  حداقل تعداد بایستی ۱۰۰۰ عدد باشد.',
    CONFIRM_DELETE_GROUP: "تایید حذف گروه؟",
  },
  SPECIAL_NUMBERS: {
    NEWS_SEND: "ارسال خبری",
  },
  POPUP_TITLES: {
    SYSTEM_GUIDE: "راهنمای سیستم",
    ERROR: "خطا",
    WARNING: "هشدار",
    SUCCESS: "موفقیت",
    CONFIRM: "تأیید",
    SELECT_GROUP: "انتخاب گروه",
    CREATE_NEW_GROUP: "ایجاد گروه جدید",
    SELECT_GROUP_SUBGROUP: "انتخاب گروه و زیرگروه",
    CREATE_DEFAULT_GROUP: "ساخت گروه پیشفرض",
    DELETE_CONTACT_FROM_GROUP: "حذف مخاطب از گروه",
    DELETE_CONTACT: "حذف مخاطب",
    SHARE_PHONEBOOK: "اشتراک گذاری دفترچه تلفن",
    SYSTEM_GUIDE: "راهنمای سامانه ترمینال تبلیغات",
  },
  CARD_TITLES: {
    ENTER_GROUP_NAME: "نام مورد نظر خود را وارد نمایید",
    SELECT_PERMISSIONS: "انتخاب دسترسی برای دفترچه تلفن {name}:",
    PEOPLE_WITH_ACCESS: "افرادی که دسترسی دارند",
  },
  LOADING_MESSAGES: {
    FETCHING_CATEGORIES: "درحال بارگیری دسته‌بندی‌ها...",
  },
  RADIO_LABELS: {
    GROUP_WITH_SUBGROUPS: "گروه به همراه زیر گروه ها اضافه شود",
    SELECTED_GROUP_ONLY: "گروه انتخاب شده فقط اضافه شود",
    DELETE_FROM_THIS_GROUP_ONLY: "مخاطب فقط از این گروه حذف شود",
    DELETE_FROM_ALL_GROUPS: "مخاطب از کلیه گروه‌ها حذف شود",
  },
  FILTER_LABELS: {
    ADDRESS: "آدرس",
    EMAIL: "ایمیل",
    WEBSITE: "وبسایت",
    CUSTOM_FIELD: "فیلد سفارشی",
    DATE: "تاریخ",
  },
  CARD_SUBTITLES: {
    SHARE_INSTRUCTION:
      "با انتخاب هریک از موارد زیر، دسترسی مورد نظر را با دیگران به اشتراک بگذارید.",
  },
  VALIDATION: {
    INVALID_PHONE_NUMBER: "شماره تلفن صحیح وارد نماید",
  },
  LIST_ITEM_TITLES: {
    DELETE: "حذف",
    EDIT: "ویرایش",
    ADD: "افزودن",
    REMOVE_ACCESS: "برداشتن دسترسی",
  },
  CAMPAIGN: {
    CAMPAIGN_NAME: "نام کمپین",
    TEXT: "متن",
    MESSAGE: "پیام",
    FOR: "برای",
    SELECT_CAMPAIGN: "انتخاب کمپین",
    CLICK_ROW: "روی ردیف مورد نظر کلیک کنید.",
    NEW: "جدید",
    SUBMIT_CAMPAIGN: "ثبت کمپین",
    TIME: "ساعت",
    MESSAGE_COUNT: "تعداد پیام",
    PAGE_COUNT: "مجموع پیام (صفحه)",
    PAGE: "صفحه",
    CANCEL_TEXT: "لغو11",
    TRACKABLE_LINK: "لینک قابل رهگیری",
    WARNING_TEXT: "لطفا متن/های کمپین انتخابی خود را تصحیح نمایید!",
    WARNING_TITLE: "لطفا عنوان/های کمپین انتخابی خود را تصحیح نمایید!",
    WARNING_GAP: "لطفا فاصله زمانی/های کمپین انتخابی خود را تصحیح نمایید!",
    WARNING_OPERATOR: "لطفا اپراتور/های کمپین انتخابی خود را تصحیح نمایید!",
    MAX_ITEMS_ERROR: "حداکثر 10 مورد میتوان اضافه نمود.",
  },
  ADS: {
    LIVE_SMS: "ارسال پیامک زنده",
    BUY_JOB_DB: "خرید بانک اطلاعات مشاغل",
    SMART_LADDER: "نردبان هوشمند آگهی دیوار",
    JOB_SMS: "ارسال پیامک به مشاغل",
    WEB_DESIGN: "سفارش طراحی سایت",
    SEO: "سفارش سئو سایت",
    MAP_SMS: "ارسال پیامک از نقشه",
    GRADUAL_LADDER: "نردبان تدریجی آگهی دیوار",
    SEO_ALT: "سفارش سئو سایت",
    SITE_SUPPORT: "مدیریت و پیشتبانی سایت",
    CITY_SMS: "ارسال پیامک به شهر و استان",
    AUTO_CHAT: "چت اتوماتیک دیوار",
  },
  TUTORIALS: {
    WHATSAPP_SUPPORT: "ارتباط در واتساپ",
    TICKET_SUPPORT: "ثبت تیکت",
  },
  INCREASE: {
    PAN: "شماره کارت",
    CVV2: "CVV2",
    MONTH: "ماه",
    YEAR: "سال",
    PIN2: "رمز دوم",
    GET_OTP: "دریافت رمز دوم",
    PAY: "پرداخت",
    INVALID_PAN: "شماره کارت صحیح نمی باشد",
    INVALID_CVV2: "رمز CVV2 صحیح نیست",
  },
  WALLET: {
    CustomCharge: "شارژ کیف پول",
    withdrawTitle: "برداشت از کیف پول",
    transactionListTooltip: "لیست تراکنش های شما",
    reloadTooltip: "بارگزاری مجدد",
    withdrawTooltip: "برداشت از کیف پول",
    AmountLabel: "اعتبار ",
    SelectAmount: "انتخاب مبلغ",
    Amount: "مبلغ",
    Currency: "ریال",
    GateWay: "درگاه پرداخت",
    noGateWay: "درگاهی یافت نشد",
    Pay: "پرداخت",
    PriceNotInRange: "مبلغ باید بین {min} تا {max} باشد.",
    ErrorOnRedirectToGateWay: "خطا در انتقال به درگاه پرداخت",
    ErrorGeneral: "خطا",
    MinAmountError: "مبلغ وارد شده کمتر از حداقل مجاز است.",
    MinBazarAmountError: "مبلغ کمتر از ۱۰ هزار تومان نمیتواند باشد!",
    BazarSuccessInfo:
      "در صورت پرداخت موفق، 1 الی 3 دقیقه زمان لازم است تا کیف پول شما شارژ شود.",
    withdrawableBalance: "موجودی قابل برداشت",
    withdrawFee: "کارمزد برداشت از حساب: ۵۰,۰۰۰ ریال می باشد!",
    selectAccount: "انتخاب حساب",
    addAccount: "افزودن حساب",
    submitWithdraw: "ثبت برداشت",
    accountRequiredInfo: "ورود کلیه اطلاعات الزامی است.",
    ownerName: "نام صاحب حساب",
    ownerLastName: "نام خانوادگی",
    bankName: "نام بانک",
    accountNumber: "شماره حساب",
    cardNumber: "شماره کارت",
    sheba: "شماره شبا",
    onlyPersian: "فقط مجاز به ورود حروف فارسی!",
    cardNumberLength: "تعداد ارقام شماره کارت باید ۱۶ عدد باشد!",
    shebaLength: "تعداد ارقام شماره شبا باید ۲۴ عدد باشد!",
  },
  USER_PICKER: {
    SELECT_USER: "انتخاب کاربر",
    SELECT_USERS: "انتخاب کاربران",
    SEARCH: "جستجو",
    PERSON: "شخص حقیقی",
    COMPANY: "شخص حقوقی",
    ID: "شناسه",
    NAME: "نام",
    LASTNAME: "نام خانوادگی",
    USERNAME: "نام کاربری",
    PHONE: "شماره همراه",
    TYPE: "نوع کاربر",
  },
  NEWS: {
    TITLE: "اخبار پیامک لند",
    VIEW_BUTTON: "مشاهده",
    NO_NEWS: "خبر تازه ای نیست.",
    FETCH_ERROR: "خطا در دریافت اخبار!",
  },
  MENUS: {
    CONTACT_LIST: "لیست تماس‌ها",
    FINDPREFIX: "جستجوی پیشوند",
    // سامانه‌ها
    TICKET_REGISTRATION: "ثبت تیکت",
    AD_TERMINAL_SYSTEM: "سامانه بزرگ ترمینال تبلیغات",
    WALLET_TRANSACTIONS: "تراکنش‌های کیف پول",
    DYNAMIC_QR_SYSTEM: "سامانه ساخت کیوآر داینامیک",
    DIVAR_AD_SYSTEM: "سامانه درج و مدیریت آگهی دیوار",
    GRAPHIC_DESIGN_SYSTEM: "سامانه سفارش طراحی گرافیکی، چاپ",
    DIGITAL_MARKETING_SYSTEM: "سامانه مدیریت دیجیتال مارکتینگ",
    BULK_SMS_SYSTEM: "سامانه ارسال پیامک انبوه",
    BUSINESS_INFO_SYSTEM: "سامانه بانک اطلاعات مشاغل کشور",
    AD_MANAGEMENT_SYSTEM: "سامانه مدیریت آگهی تبلیغاتی",
    GRAPHIC_VIDEO_SERVICES: "سامانه خدمات طراحی گرافیکی و ویدئو",
    // ابزارهای کیوآر
    QR_TOOL: "ابزار کیوآر",
    CREATE_DYNAMIC_QR: "ساخت کیوآر داینامیک",
    QR_MANAGEMENT: "مدیریت کیوآر",
    QR_MONITORING: "مانیتورینگ کیوآرها",
    MY_QR_LIST: "لیست کیوآرهای من",
    PHYSICAL_NFC_ORDERS: "سفارشات کارت فیزیکی و NFC",
    BULK_QR_GENERATION: "ساخت گروهی کیوآر کد",
    IMAGE_CREATION_TOKEN: "توکن خلق تصویر",
    QR_SMS: "کیوآر پیامک",
    QR_LINK: "کیوآر لینک",
    QR_TEXT: "کیوآر متن",
    QR_LOCATION: "کیوآر لوکیشن / مکان",
    QR_EMAIL: "کیوآر ایمیل",
    QR_CALL: "کیوآر تماس",
    QR_WIFI: "کیوآر وای فای",
    VISIT_STATISTICS: "آمار بازدید",
    // مدیریت آگهی‌ها
    AD_MONITORING: "مانیتورینگ آگهی‌ها",
    DIVAR_NEWS: "تازه‌های دیوار",
    REAL_ESTATE_AD_SUBMISSION: "ارسال آگهی پنل املاک",
    AUTO_AD_RENEWAL: "تمدید اتوماتیک آگهی‌ها",
    GRADUAL_AD_SUBMISSION: "ارسال آگهی تدریجی",
    SMART_AD_SUBMISSION: "ارسال آگهی هوشمند",
    DEFAULT_AD_REGISTRATION: "ثبت آگهی پیشفرض",
    AD_ANALYZER: "آنالیزور بازدید آگهی",
    ADD_AD_PHOTO: "افزودن عکس آگهی",
    SMART_LADDER: "نردبان هوشمند",
    GRADUAL_LADDER: "نردبان تدریجی",
    ADS_LIST: "لیست آگهی‌ها",
    AD_REPORTS: "گزارشات آگهی",
    SCHEDULED_AD_SUBMISSION: "ارسال آگهی زماندار",
    SCHEDULED_AD_LIST: "لیست آگهی زماندار",
    PERSONAL_AD_SUBMISSION: "ارسال آگهی شخصی",
    TARGET_TOOLS: "ابزار هدفمند",
    SMART_LIST: "لیست هوشمند/تدریجی",
    // پیامک
    SEND_TO_CUSTOMER_CLUB: "ارسال به باشگاه مشتریان",
    BULK_SMS: "ارسال پیامک انبوه",
    LIVE_SMS: "ارسال پیامک زنده (قدیم)",
    SEND_TO_BUSINESSES: "ارسال به مشاغل کشور",
    SMS_BY_MAP: "ارسال پیامک از نقشه",
    CITY_PROVINCE_SMS: "ارسال شهر و استان",
    RECEIVED_SMS_LIST: "لیست دریافت پیامک",
    SMS_TEXT_CONSULTANT: "مانیتور مشاور متن پیامک",
    DEFAULT_TEXT_CONSULTATION: "متن پیشفرض + مشاوره",
    ADMIN_SMS_SUBMISSIONS: "ارسالی‌های ادمین",
    PENDING_SMS: "پیامک منتظر تأیید",
    ADMIN_RECEIVED_REPORT: "گزارش دریافتی ادمین",
    PATTERN: "پترن/الگو",
    SMS_REPORTS: "گزارش ارسال‌ها",
    DEDICATED_LINE_REQUESTS: "درخواست‌های خط اختصاصی",
    PHONEBOOK: "دفترچه تلفن",
    SMS_TARIFFS: "تعرفه‌های پیامک",
    LINE_CATEGORIES: "دسته‌بندی خطوط",
    TARIFF_COEFFICIENTS: "ضرایب تعرفه ارسال",
    SEND_ADMIN_SMS: "ارسال SMS ادمین",
    // شماره‌ها و مخاطبین
    ADD_NEW_NUMBER: "افزودن شماره جدید",
    NUMBERS: "شماره‌ها",
    USER_NUMBERS: "شماره‌های کاربران",
    REGISTER_USER_NUMBER: "ثبت شماره برای کاربر",
    NUMBER_LIST: "لیست شماره‌های من",
    CREATE_NUMBER_TARIFF: "ایجاد تعرفه شماره‌ها",
    NUMBER_TARIFF_LIST: "لیست تعرفه شماره‌ها",
    OTHER_TARIFF_LIST: "لیست دیگر تعرفه‌ها",
    // مدیریت مالی
    WALLET: "کیف پول جدید",
    TRANSFER_REQUESTS: "درخواست برداشت",
    DIVAR_PAYMENTS: "پرداختی‌های دیوار",
    AUTO_PAYMENT: "پرداخت اتوماتیک",
    PAYMENTS: "پرداخت‌ها",
    PAYMENT_GATEWAY: "درگاه پرداخت",
    BUY_CHARGE: "خرید شارژ",
    // مدیریت مشتریان و کاربران
    CUSTOMERS: "مشتریان",
    CRM_CUSTOMERS: "CRM مشتریان",
    CONTACT_LIST: "تماس یار (تشکر از تماس)",
    USERS: "لیست کاربران",
    USER_REQUESTS: "درخواست‌های کاربران",
    PROFILE: "پروفایل",
    USER_HISTORY_NOTIFICATIONS: "اعلانات تاریخچه کاربران",
    // طراحی و محتوا
    WEBSITE_DESIGN_ORDER: "سفارش طراحی سایت",
    SEO_ORDER: "سفارش سئو سایت",
    BUY_INFO_DATABASE: "خرید بانک اطلاعاتی",
    BUY_MOBILE_DATABASE: "خرید بانک شماره همراه",
    PURCHASED_ARCHIVES: "آرشیوهای خریداری‌شده",
    FAVORITE_ARCHIVES: "آرشیوهای مورد علاقه",
    UPLOAD_CENTER: "آپلود سنتر",
    CONTENT: "محتوا",
    // مدیریت و تنظیمات
    MONITORING: "مانیتورینگ",
    MANAGEMENT: "مدیریت",
    SETTINGS: "تنظیمات",
    CATEGORIES: "دسته‌بندی",
    DOMAINS: "دامنه‌ها",
    REMINDERS: "یادآوری",
    AUTOMATIC_CREATION: "ساخت اتوماتیک",
    PERMISSIONS: "پرمیشن‌ها",
    ROLES: "نقش‌ها",
    MENUS: "منوها",
    CORE_MANAGEMENT: "مدیریت کور",
    WORK_REPORTS: "مدیریت گزارش کار",
    WORK_REPORT_CREATE: "گزارش کار",
    DEPARTMENTS: "دپارتمان‌ها",
    DISCOUNTS: "تخفیف‌ها",
    NOTIFICATIONS: "اعلانات",
    ADMIN_NOTIFICATIONS: "اعلانات مدیر",
    TICKET_MANAGEMENT: "مدیریت تیکت",
    USER_GUIDE: "راهنمای کاربر",
    CAMPAIGN: "کمپین",
    MESSAGE_CATEGORIES: "دسته‌بندی پیام‌ها",
    REGISTERED_INFO_LIST: "لیست اطلاعات ثبت‌شده",
    TARIFFS: "تعرفه‌ها",
    INFORMATION_REGISTRATION: "ثبت اطلاعات",
    UNCREATED_CARDS: "کارت‌های ساخته‌نشده",
    MODELS_LIST: "لیست مدل‌ها",
    CREATE_DEFAULT_PRODUCT: "ساخت محصول پیشفرض",
    EXCEL_FILES: "فایل‌های اکسل",
    AUTO_CHATS: "چت هوشمند",
    AUTO_CHAT: "چت اتوماتیک",
    // سایر
    MY_FILES: "فایل‌های من",
    CONSULTANTS: "مشاوران",
    ADD_DIVAR_NEWS: "افزودن تازه‌های دیوار",
    BUY_PANEL: "خرید پنل",
    PANELS: "پنل‌ها",
    CALL_MONITORING: "مانیتور تماس",
    INFO_REVIEW: "بررسی اطلاعات",
    MESSAGES: "پیام‌ها",
    PERSONNEL: "پرسنل",
    //qr
    QR_TOOL: "ابزار کیوآر",
    CREATE_DYNAMIC_QR: "ساخت کیوآر داینامیک",
    QR_MANAGEMENT: "مدیریت کیوآر",
    QR_MONITORING: "مانیتورینگ کیوآرها",
    MY_QR_LIST: "لیست کیوآرهای من",
    PHYSICAL_NFC_ORDERS: "سفارشات کارت فیزیکی و NFC",
    BULK_QR_GENERATION: "ساخت گروهی کیوآر کد",
    IMAGE_CREATION_TOKEN: "توکن خلق تصویر",
    CATEGORIES: "دسته‌بندی",
    CREATE_DEFAULT_PRODUCT: "ساخت محصول پیشفرض",
    DOMAINS: "دامنه ها",
    REMINDERS: "یادآوری",
    AUTOMATIC_CREATION: "ساخت اتوماتیک",
    SEND_ADMIN_SMS: "ارسال sms ادمین",
    UNCREATED_CARDS: "کارت های ساخته نشده",
    MODELS_LIST: "لیست مدل ها",
    UPLOAD_CENTER: "آپلود سنتر",
    INFORMATION_REGISTRATION: "ثبت اطلاعات",
    TARIFFS: "تعرفه ها",
    REGISTERED_INFO_LIST: "لیست اطلاعات ثبت شده",
    //code
    personel: "پرسنل",
    "workReports/create": "گزارش کار",
    "admin/user-guide": "راهنمای کاربر",
    phonebook: "باشگاه مشتریان",
    contactlist: "تماس یار (تشکر از تماس)",
    "contact/list": "تماس یار (تشکر از تماس)",
    "admin/transferRequests": "درخواست برداشت",
    "admin/wallet": "کیف پول جدید",
    "admin/cdr": "مانیتور تماس",
    "admin/campaign": "کمپین",
    "admin/message-categories": "دسته بندی پیام ها",
    "admin/customers": "CRM مشتریان",
    "admin/notifications": "اعلانات مدیر",
    "admin/user-history/notifications": "اعلانات تاریخچه کاربران",
    "admin/messages": "پیام ها",
    profile: "پروفایل",
    "admin/workReports": "مدیریت گزارش کار",
    panel: "خرید پنل",
    adminDiscounts: "تخفیف ها",
    departments: "دپارتمان ها",
    adminTickets: "مدیریت تیکت",
    "admin/configs": "تنظیمات",
    notifications: "اعلانات",
    "user/confirmed": "درخواست های کاربران",
    users: "لیست کاربران",
    payments: "درگاه پرداخت",
    permission: "پرمیشن ها",
    panels: "پنل ها",
    category: "منوها",
    content: "محتوا",
    role: "نقش ها",
    "core/admin": "مدیریت کور",
    //robot
    numberList: "لیست شماره های من",
    registerAd: "ثبت آگهی",
    proPanelSendAd: "ارسال آگهی پنل حرفه ای",
    buyCharge: "خرید شارژ",
    scheduledAdSend: "ارسال آگهی زماندار",
    smartGradual: "هوشمند/تدریجی",
    createNumberTariff: "ایجاد تعرفه شماره‌ها",
    numberTariffList: "لیست تعرفه شماره ها",
    otherTariffList: "لیست دیگر تعرفه‌های",
    userNumbers: "شماره‌های کاربران",
    numbers: "شماره‌ها",
    management: "مدیریت",
    settings: "تنظیمات",
    registerUserNumber: "ثبت شماره برای کاربر",
    divarPayments: "پرداختی های دیوار",
    autoPayment: "پرداخت اتوماتیک",
    adAnalyzer: "آنالیزور بازدید آگهی",
    infoReview: "بررسی اطلاعات",
    rb_payments: "پرداخت‌ها",
    autoChat: "چت اتوماتیک",
    ads: "آگهی‌ها",
    monitoring: "مانیتورینگ",
    smartLadder: "نردبان هوشمند",
    gradualLadder: "نردبان تدریجی",
    excelFiles: "فایل های اکسل",
    autoChats: "چت هوشمند",
    addAdPhoto: "افزودن عکس آگهی",
    targetTools: "ابزار هدفمند",
    smartList: "لیست هوشمند/تدریجی",
    scheduledAdList: "لیست آگهی زماندار",
    adsList: "لیست آگهی ها",
    adReports: "گزارشات آگهی",
    personalAdSend: "ارسال آگهی شخصی",
  },
  AUTO_REFRESH_POPUP: {
    TITLE: "زمان مورد نظر خود را وارد نمایید:",
    SUBTITLE:
      "پس از تعیین زمان، این صفحه در زمان انتخاب شده همیشه رفرش می‌شود.",
    TIME_LABEL: "زمان",
  },
  MODAL: {
    OK_TITLE: "تایید",
  },

  ROUTE: {
    TITLES: {
    QR_NAME_EDIT_TEXT:"ویرایش کیوآر متن",
    SERVER_DOWN: "در حال به روزرسانی",
    CREATE_MEMORIES_MODEL: "ساخت مدل قاب خاطره",
    CREATE_CARD_VISIT_PRO_MODEL: "ساخت مدل کارت ویزیت پرو",
    CREATE_PRODUCT_PRO_MODEL: "ساخت مدل معرفی محصول پرو",
    CREATE_PRODUCT_LABEL_MODEL: "ساخت مدل لیبل محصول",
    CREATE_PHOTO_GALLERY_MODEL: "ساخت مدل گالری تصویر",
    CREATE_PDF_GALLERY_MODEL: "ساخت مدل گالری پی دی اف",
    CREATE_SOCIAL_MEDIA_MODEL: "ساخت مدل شبکه اجتماعی",
    EDIT_CARD_VISIT_PRO_MODEL: "ویرایش مدل کارت ویزیت پرو",
    EDIT_PRODUCT_PRO_MODEL: "ویرایش مدل معرفی محصول پرو",
    EDIT_PRODUCT_LABEL_MODEL: "ویرایش مدل لیبل محصول",
    EDIT_PHOTO_GALLERY_MODEL: "ویرایش مدل گالری تصویر",
    EDIT_PDF_GALLERY_MODEL: "ویرایش مدل گالری پی دی اف",
    EDIT_SOCIAL_MEDIA_MODEL: "ویرایش مدل شبکه اجتماعی",
    BOOK: "دفترچه / کتاب",
    NFC_LIST: "لیست NFC ها",
    API_KEY_MANAGER: "ساخت کلید API",
    PRE_PURCHASE: "پیش خرید",
    PRE_PURCHASE_MODEL: "نمونه آماده",
      QR_NAME_EDIT_GIFT:"ویرایش کیوار کد قاب خاطره ها",
      QR_GIFT:"کیوار کد قاب خاطره ها",
      QR_CARD_VISIT_PRO:"گارت ویزیت پرو",
      QR_NAME_EDIT_PRO:"ویرایش کارت ویزیت پرو",
      QR_LINK_EDIT_pro: "ویرایش کیوار کلیک یار سئو",
      "QR_LINK_PRO": "کیوار کلیک یار سئو",
      DIGI: "مونیتورینگ قیمت‌گذار دیجی‌کالا",
      QR_PDF: "گالری پی دی اف",
      QR_NAME_EDIT_PDF: "ویرایش گالری پی دی اف",
      QR_MULTICART: "کیوار مولتی کارت",
      QR_MULTICART_EDIT: "ویرایش مولتی کارت کیوار",
      QR_NAME_PRODUCTPRO: "ویرایش معرفی محصول پرو",
      QR_PRODUCTPRO: "معرفی محصول پرو",
      QR_LUCK_WHEEL_Edit: "ویرایش گردونه شانس",
      QR_NAME_EDIT_CATALOG: "ویرایش کاتالوگ",
      QR_LUCK_WHEEL: "ساخت کیو آر گردونه شانس",
      DASHBOARD: "داشبورد",
      ADMIN_QR_DOMAINS: "مانیتورینگ دامنه‌ها",
      ADMIN_TOGETHER_TOKEN: "مانیتورینگ توکن‌ها",
      ADMIN_QR_SMS: "ارسال پیامک",
      MENU_PROFILE_INFO: "اطلاعات کاربر",
      MENU_PROFILE_SETTING: "تنظیمات پروفایل",
      MENU_PROFILE_ORDERS: "سفارش‌ها",
      MENU_PROFILE_ADDRESSES: "آدرس‌ها",
      QR_MONITORING: "مانیتورینگ کیوآر",
      QR_LIST: "لیست کیوآرهای من",
      QR_NAME_LIST: "مدیریت مشارکت",
      QR_GENERATE_MULTIPLE: "ساخت گروهی کیوآر کد",
      QR_CARD_VISIT: "ساخت کارت ویزیت",
      HELP_INFO: "تست دکمه",
      QR_MENU: "منو فروشگاهی",
      QR_APPOINTMENT: "نوبت‌دهی",
      QR_INSURANCE: "ساخت بیمه آنلاین",
      QR_BPAGE: "ساخت صفحه کاری",
      QR_CPAGE: "ساخت سایت مجتمع تجاری/اداری",
      QR_BSHOP: "فروشگاه آنلاین",
      QR_NAME_EDIT_BSHOP: "ویرایش فروشگاه آنلاین",
      QR_LINK_EDIT: "ویرایش لینک",
      QR_NAME_DESIGN: "ویرایش دیزاین",
      QR_NAME_SETTING: "ویرایش تنظیمات",
      QR_NAME_EDIT: "ویرایش کارت ویزیت",
      QR_NAME_EDIT_BPAGE: "ویرایش صفحه کاری",
      QR_EDIT_CPAGE: "ویرایش سایت مجتمع تجاری/اداری",
      QR_NAME_INSURANCE: "ویرایش بیمه آنلاین",
      QR_NAME_EDIT_MENU: "ویرایش منو",
      QR_NAME_EDIT_APPLICATION: "ارائه اپلیکیشن",
      QR_NAME_EDIT_APPOINTMENT: "ویرایش نوبت‌دهی",
      QR_NAME_EDIT_PHOTO: "ویرایش گالری عکس",
      QR_NAME_EDIT_VIDEO: "ویرایش گالری ویدئو",
      QR_NAME_EDIT_VOICE: "ویرایش گالری صوتی",
      QR_NAME_EDIT_FEEDBACK: "ویرایش گالری بازخورد",
      QR_NAME_CONSULTATION_QR_EDIT: "ویرایش فرم درخواست",
      QR_NAME_EDIT_VOICE_PRO: "ویرایش گالری صوتی (پرو)",
      QR_NAME_EDIT_SOCIAL: "ویرایش شبکه‌های اجتماعی",
      QR_NAME_STATISTICS: "آمار کد کیوآر",
      QR_CATE: "انتخاب دسته",
      QR_SHARE: "اشتراک‌گذاری",
      QR_BUSINESS_SHOP: "بیزینس/فروشگاه",
      QR_CO_ORGAN: "شرکتی/سازمانی",
      QR_CONTACT: "ارتباط با مشتری",
      QR_NOTICES: "اطلاع‌رسانی",
      QR_OTHERS: "متفرقه",
      QR_STATICS: "کیوآر استاتیک",
      QR_DYNAMICS: "کیوآر داینامیک",
      QR_D_BUSINESS: "کیوآر داینامیک بیزینسی",
      QR_D_ORGANS: "کیوآر داینامیک سازمانی",
      QR_D_GOVERNMENT: "کیوآر داینامیک دولتی",
      QR_VIDEO: "گالری ویدئو",
      QR_APPLICATION: "ارائه اپلیکیشن",
      QR_VOICE: "گالری صوتی",
      QR_VOICE_PRO: "گالری صوتی (پرو)",
      QR_CONSULTATION_QR: "فرم درخواست",
      QR_FEEDBACK: "گالری بازخورد",
      QR_PHOTO: "گالری عکس",
      QR_CATALOG: "کاتالوگ / بروشور",
      QR_LOCATION: "ساخت کیوآر مکان",
      QR_SOCIAL_MEDIA: "ساخت کیوآر شبکه اجتماعی",
      QR_LINK: "ساخت لینک",
      QR_TEXT: "ساخت متن",
      QR_MAIL: "ساخت ایمیل",
      QR_CALL: "تماس",
      QR_SMS: "پیامک",
      QR_WHATSAPP: "واتساپ",
      QR_SITE: "وبسایت",
      QR_INSTAGRAM: "اینستاگرام",
      QR_SKYPE: "اسکایپ",
      QR_WIFI: "وایفای",
      QR_BUSINESS: "صفحه کاری",
      QR_DISCOUNT: "صفحه تخفیف",
      QR_PRODUCT_SHOP: "معرفی محصول",
      QR_PRODUCT_LABEL: "لیبل محصول",
      QR_GOLD_LABEL: "لیبل طلا",
      QR_PRODUCT_TEMPLATE: "محصولات",
      ADMIN_CATEGORY: "دسته‌بندی‌ها",
      QR_NFC_ORDERS: "کارت NFC منتظر تأیید",
      QR_NAME_PRODUCT: "ویرایش معرفی محصول",
      QR_NAME_LABELPRODUCT: "ویرایش لیبل محصول",
      QR_NAME_GOLDPRODUCT: "ویرایش لیبل طلا",
      QR_COINS: "رمزارزها",
      QR_SHOP: "مدیریت فروشگاه",
      QR_TWITTER: "توییتر",
      UPLOAD_CENTER: "آپلود‌سنتر",
      PRICING: "تعرفه‌های کیوآر",
      QR_CREATE_MODELS: "ساخت مدل کارت ویزیت",
      QR_CREATE_BUSINESS_MODELS: "ساخت مدل صفحه کاری",
      QR_CREATE_PRODUCT_MODEL: "ساخت مدل کارت محصول",
      QR_CREATE_MENU_MODELS: "ساخت مدل منو فروشگاهی",
      QR_CREATE_SHOP_MODEL: "ساخت مدل فروشگاه آنلاین",
      MODELS_LIST: "انواع مدل‌های کیوآر",
      MODELS_LIST_EDIT: "ویرایش مدل",
      MODELS_LIST_MENU_EDIT: "ویرایش مدل منو",
      MODELS_LIST_BMODEL_EDIT: "ویرایش مدل فروشگاه آنلاین",
      NFC: "کارت‌های NFC",
      SUBMIT_FORM: "ثبت بلاگر",
      REQUEST_LIST: "لیست بلاگرها",
      PURE_DATA: "لیست کارت ویزیت‌های ساخته نشده",
      AUTO_CREATE: "ساخت اتوماتیک کیوآر",
      QR_CREATE: "ساخت کیوآر",
      HISTORY_REMINDER: "مونیتورینگ یادآوری",
      BOOK: "مونیتورینگ یادآوری"
    },
  },
  qr_management: "مدیریت Qr",
  router: {
    dashboard: "داشبورد",
    contacts: "باشگاه مشتریان",
    editContact: "ویرایش مشتری",
    createContact: "ایجاد مشتری",
    customers: "لیست مشتریان",
    contactList: "تماس یار",
    messages: "پیام‌ها",
    messageCategories: "دسته‌بندی پیام‌ها",
    oldTransactions: "تراکنش‌های قدیمی",
    yourTransactions: "تراکنش‌های شما",
    buyPanel: "خرید پنل",
    permissions: "دسترسی‌ها",
    createPermission: "ایجاد پرمیشن",
    invitations: "لیست دعوتی‌های من",
    editUser: "ویرایش کاربر",
    userInformation: "مشاهده اطلاعات کاربر",
    walletEdit: "ویرایش اطلاعات کیف پول کاربر",
    userHistory: "تاریخچه کاربر",
    userNotificationsHistory: "تاریخچه اعلانات کاربران",
    notifications: "اعلانات",
    createNotification: "ایجاد اعلان",
    editNotification: "ویرایش اعلان",
    adminNotifications: "اعلانات ادمین",
    yourNotifications: "اعلانات شما",
    adminNotificationsList: "اعلانات مدیر",
    tickets: "تیکت‌ها",
    createTicket: "ثبت تیکت جدید",
    editTicket: "ویرایش تیکت",
    departments: "دپارتمان‌ها",
    createDepartment: "دپارتمان جدید",
    editDepartment: "ویرایش دپارتمان",
    adminTickets: "مدیریت تیکت‌ها",
    discounts: "تخفیف‌ها",
    createDiscount: "ایجاد تخفیف",
    editDiscount: "ویرایش تخفیف",
    workReports: "گزارش کار",
    createWorkReport: "ایجاد گزارش کار",
    callMonitoring: "مانیتورینگ تماس",
    adminWorkReports: "مدیریت گزارش کار",
    editWorkReport: "نمایش و ویرایش گزارش کار",
    packProperties: "ویژگی‌های بسته",
    createPackProperty: "ایجاد ویژگی بسته",
    editPackProperty: "ویرایش ویژگی بسته",
    panels: "پنل‌ها",
    createPanel: "ایجاد پنل",
    editPanel: "ویرایش پنل",
    transferRequests: "درخواست‌های برداشت",
    editTransferRequest: "ویرایش درخواست برداشت",
    tariffs: "تعرفه‌ها",
    createTariff: "ایجاد تعرفه",
    editTariff: "ویرایش تعرفه",
    requests: "درخواست‌ها",
    viewUser: "مشاهده کاربر",
    manageTransactions: "مدیریت تراکنش‌ها",
    viewTransaction: "مشاهده تراکنش",
    manageConfigs: "مدیریت تنظیمات",
    rbLandConfigs: "مدیریت تنظیمات ربات لند",
    editConfig: "ویرایش تنظیمات",
    manageUsers: "مدیریت کاربران",
    categories: "دسته‌بندی‌ها",
    createCategory: "افزودن دسته‌بندی",
    editCategory: "ویرایش دسته‌بندی",
    content: "محتوا",
    createContent: "درج محتوا",
    editContent: "ویرایش محتوا",
    addUserGuide: "افزودن راهنمای کاربر",
    editUserGuide: "ویرایش راهنمای کاربر",
    roles: "نقش‌ها",
    editRole: "ویرایش نقش",
    createRole: "افزودن نقش",
    permissionTitle: "دسترسی‌ها", // For cruds.permission.title
    paymentGateways: "درگاه‌های پرداخت",
    editPaymentGateway: "ویرایش درگاه‌های پرداخت",
    campaigns: "کمپین‌ها",
    createCampaign: "ایجاد کمپین",
    editCampaign: "ویرایش اطلاعات کمپین",
    adminCustomers: "مشتریان",
    createCustomer: "ایجاد مشتریان",
    editCustomerInfo: "ویرایش اطلاعات مشتری",
    referrerCustomers: "مشتریان معرف",
    customerHistory: "تاریخچه‌ی مشتری",
    userProfile: "پروفایل کاربری",
    editProfile: "ویرایش پروفایل",
    inviteFriends: "دعوت از دوستان",
    personalInfo: "اطلاعات شخصی",
    editPersonalInfo: "ویرایش اطلاعات",
    changePassword: "تغییر رمز عبور",
    newWallet: "کیف پول جدید",
  },
  ticket: {
    text: "ثبت تیکت",
  },
    LANGUAGE:{
    Persian:'فارسی',
    English:'انگلیسی',
  },

};
